import RecentActivityInformationHeader from './RecentActivityInformationHeader'

export default RecentActivityInformationHeader
